var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-input',{staticClass:"custom-input",attrs:{"value":_vm.value,"placeholder":_vm.placeholder,"type":"type"},on:{"input":_vm.input,"blur":_vm.blur}})}
var staticRenderFns = []

export { render, staticRenderFns }